import i18n from "../i18n";

export const getDate = ({
  timestamp,
  options = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  },
  locale = null,
}: {
  timestamp: number;
  options?: Intl.DateTimeFormatOptions;
  locale?: string | null;
}) => {
  const date = new Date(timestamp * 1000);

  if (locale === null) {
    switch (i18n.global.locale.value) {
      case "de":
        locale = "de-DE";
        break;
      case "fr":
        locale = "fr-FR";
        break;
      case "en":
      default:
        locale = "en-EN";
        break;
    }
  }

  options.timeZone = "Europe/Berlin";

  return new Intl.DateTimeFormat(locale, options).format(date);
};
